<template>
    <div class="c-sticky-footer-wrapper o-master-wrapper u-bgcolor-white-base">
        <div class="c-sticky-footer">
            <app-header v-if="isLoggedIn"></app-header>
            <router-view></router-view>

            <notifications group="global" position="bottom right">
                <template slot="body" slot-scope="props">
                    <div class="c-notification" :class="props.item.type">
                        <svgicon name="check" v-if="props.item.type === 'success'"></svgicon>
                        <div>
                            <p class="c-notification__title">{{props.item.title}}</p>
                            <div class="c-notification__text" v-html="props.item.text"></div>
                        </div>
                        <button type="button" class="c-notification__close c-button--reset c-button--icon u-flex--push-left" @click="props.close">
                            <svgicon name="close"></svgicon>
                        </button>
                    </div>
                </template>
            </notifications>
        </div>
        <app-footer v-if="isLoggedIn"></app-footer>
    </div>
</template>

<script>
    // Import components
    import AppHeader from '@/components/common/Header'
    import AppFooter from '@/components/common/Footer'

    export default {
        components: {
            AppHeader,
            AppFooter
        },
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn;
            }
        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/layouts/Default.vue